import Icon from '../components/Icon.vue'

Icon.register({"hand-holding":{"width":576,"height":512,"paths":[{"d":"M565.3 328.1C553.5 317.4 535.1 318.1 522.7 328.1L430.3 402C419 411.1 404.9 416 390.3 416H272C263.2 416 256 408.8 256 400S263.2 384 272 384H350.3C366.2 384 381 373.1 383.6 357.4 386.9 337.4 371.5 320 352 320H192C165 320 138.9 329.3 117.9 346.3L71.4 384H16C7.2 384 0 391.2 0 400V496C0 504.8 7.2 512 16 512H372.8C387.3 512 401.4 507.1 412.8 498L564 377C579.2 364.9 580.4 341.7 565.3 328.1z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/hand-holding.js
// module id = Jy5H
// module chunks = 0